import { SUPPORT_URL } from "../../utils/constants";
import { apifetchv2 } from "../../utils";
import { useEffect, useState } from "react";
import CollapseTrigger from "../CollapseTrigger";
import Collapsible from "react-collapsible";

const Faq = ({specificFaqs=null}) => {
  const [faqData, setFaqData] = useState([]);
  

  useEffect(() => {
    let url = `${SUPPORT_URL}/faq/type?page=0&size=10&type=CICOD`;
    const options = { url, catchCallback: () => {} };
    apifetchv2(options).then(data => {
      if (data && data.isSuccessful && Array.isArray(data.object)) {
        let faqs = data.object.map(faq => faq);
        setFaqData(faqs);
      }
    });
  }, []);
  
  // setFaqData(specificFaqs)
  return (
    <>
      {
        specificFaqs ? specificFaqs.map((faq,idx)=>{
          return (
            <Collapsible
            key={faq.id}
            trigger={<CollapseTrigger title={faq.question} />}
            triggerTagName="div">
            {<p>{faq.answers}</p>}
          </Collapsible>
          )
        }) : 
       faqData.length < 1 && (
        <>
          <h3>There are currently no FAQs</h3>
        </>
      )}
      {!specificFaqs && faqData.length > 0 &&
        faqData.map(faq => (
          <Collapsible
            key={faq.id}
            trigger={<CollapseTrigger title={faq.question} />}
            triggerTagName="div">
            {<p>{faq.answers}</p>}
          </Collapsible>
        ))
      }
      

    </>
  );
};

export default Faq;
